import { Link } from "react-router-dom";
import { formatMatchWhenShort } from "../../domain/profile/profileDashboardStats";
import v from "./traVisual.module.css";

function activityTitle(card) {
  const opp = card.opponentsTeamLine || card.opponentsLabel || "Opponents";
  return `${card.isWin ? "Won" : "Lost"} vs ${opp}`;
}

function setScoreLine(card) {
  const cols = card.setColumns || [];
  if (cols.length) {
    return cols.map((col) => `${col.my}–${col.opp}`).join(" · ");
  }
  return card.scoreSummary || card.finalScore || "";
}

/**
 * Recent match activity row (Visual Language v2) — profile + home.
 * @param {{ card: object; to?: string; className?: string }} props
 */
export default function TRARecentMatchRow({ card, to, className }) {
  if (!card?.matchId) return null;

  const when = formatMatchWhenShort(card.completedAt).toUpperCase();
  const stickClass = card.isWin ? v.shuttleStick : `${v.shuttleStick} ${v.shuttleStickLoss}`;

  const inner = (
    <>
      <div className={v.shuttleSlot} aria-hidden>
        <div className={stickClass} />
      </div>
      <div className={v.activityBody}>
        <div className={v.activityTitle}>{activityTitle(card)}</div>
        {setScoreLine(card) ? <div className={v.activityDetail}>{setScoreLine(card)}</div> : null}
      </div>
      <div className={v.whenMono}>{when}</div>
    </>
  );

  const rowClass = `${v.activityRow}${className ? ` ${className}` : ""}`;

  if (to) {
    return (
      <Link to={to} className={rowClass} aria-label={`${activityTitle(card)}, ${when}`}>
        {inner}
      </Link>
    );
  }

  return <div className={rowClass}>{inner}</div>;
}
